
import { Component, Vue, Prop } from "nuxt-property-decorator";
//@ts-ignore
import Swiper from "@/node_modules/swiper/swiper-bundle.min";
import "swiper/swiper-bundle.min.css";

@Component
export default class SpecialInstagram extends Vue {
  @Prop() gallery!: string[];

  public current: number = 1;
  public images = this.gallery.map((g: any) => {
    return g.url;
  });

  async mounted() {
    await new Swiper(this.$refs.swiper, {
      grabCursor: true,
      slidesPerView: 3,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        paginationUpdate: this.update,
      },
    });
  }

  /**
   * Metodo di aggiornamento paginatore
   */
  update(event: any) {
    // Setto l'indice corrente
    this.current = event.realIndex + 1;
  }
}
